import { InertiaLink } from '@inertiajs/inertia-react'
import ShoppingCartOutlined from '@mui/icons-material/ShoppingCartOutlined'
import Badge from '@mui/material/Badge'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import { styled } from '@mui/material/styles'

const CustomCard = styled(Grid)({
  justifyContent: 'center',
  alignItems: 'center',
  marginLeft: 10,
  position: 'relative',
})

const CartIcon = ({ countCart }) => (
  <CustomCard>
    <IconButton component={InertiaLink} href={route('partner.cart')}>
      <Badge badgeContent={countCart.length ?? 0} color="error" max={999}>
        <ShoppingCartOutlined sx={{ color: '#fff' }} />
      </Badge>
    </IconButton>
  </CustomCard>
)
export default CartIcon
